/**
 *  获取元素左侧距离
 * @param element 元素
 */
function getElementLeft(element: HTMLElement) {
  let actualLeft = element.offsetLeft
  let current = element.offsetParent
  while (current !== null) {
    actualLeft += (current as HTMLElement).offsetLeft
    current = (current as HTMLElement).offsetParent
  }
  return actualLeft
}

/**
 * 获取元素顶部距离
 * @param element 元素
 */
function getElementTop(element: HTMLElement) {
  let actualTop = element.offsetTop
  let current = element.offsetParent
  while (current !== null) {
    actualTop += (current as HTMLElement).offsetTop
    current = (current as HTMLElement).offsetParent
  }
  return actualTop
}

/**
 * getBoundingClientRect的兼容性写法
 * @param element 元素
 */
export function getBoundingClientRectCompatible(element: HTMLElement) {
  const scrollTop = document.documentElement.scrollTop
  const scrollLeft = document.documentElement.scrollLeft
  if (element.getBoundingClientRect) {
    const rect = element.getBoundingClientRect()
    return {
      left: rect.left + scrollLeft,
      right: rect.right,
      top: rect.top + scrollTop,
      bottom: rect.bottom
    }
  } else {
    const actualLeft = getElementLeft(element)
    const actualTop = getElementTop(element)
    return {
      left: actualLeft - scrollLeft,
      right: actualLeft + element.offsetWidth - scrollLeft,
      top: actualTop - scrollTop,
      bottom: actualTop + element.offsetHeight - scrollTop
    }
  }
}

/**
 * 判断元素是否超出横向可视区域
 * @param element 元素
 * @returns {
 *  'left' 超出左方区域
 *  'right' 超出右方区域
 *  false 没超出区域
 * }
 */
export function isBeyondViewPortX(element: HTMLElement) {
  const viewPortWidth =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const sLeft = document.documentElement.scrollLeft || document.body.scrollLeft
  const elementLeft = getBoundingClientRectCompatible(element).left
  const elementW = element.offsetWidth
  // console.log(elementLeft, sLeft, elementLeft + elementW, viewPortWidth)
  if (elementLeft < sLeft) {
    return 'left'
  }
  if (elementLeft + elementW > viewPortWidth + sLeft) {
    return 'right'
  }
  return false
}

/**
 * 判断元素是否超出纵向可视区域
 * @param element 元素
 * @returns {
 *  'top' 超出上方区域
 *  'down' 超出下方区域
 *  false 没超出区域
 * }
 */
export function isBeyondViewPortY(element: HTMLElement) {
  const viewPortHeight =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  const sTop = document.documentElement.scrollTop || document.body.scrollTop
  const elementTop = getBoundingClientRectCompatible(element).top
  const elementH = element.offsetHeight
  // console.log(elementTop, sTop, elementTop + elementH, viewPortHeight)
  if (elementTop < sTop) {
    return 'top'
  }
  if (elementTop + elementH > viewPortHeight + sTop) {
    return 'down'
  }
  return false
}
